import type { SeasonalDecorPrefs } from '~/utils/seasonal/seasonalDecorPrefs'

export function querySeasonalBrandLink(): HTMLElement | null {
  return document.querySelector('header a.website-name')
}

export function applyBodySeasonalAttributes(prefs: SeasonalDecorPrefs): void {
  if (!import.meta.client) {
    return
  }
  const body = document.body
  if (!prefs.cursor) {
    body.setAttribute('data-seasonal-no-cursor', '1')
  } else {
    body.removeAttribute('data-seasonal-no-cursor')
  }
  if (!prefs.corner) {
    body.setAttribute('data-seasonal-no-corner', '1')
  } else {
    body.removeAttribute('data-seasonal-no-corner')
  }
  if (!prefs.logo) {
    body.setAttribute('data-seasonal-no-logo', '1')
  } else {
    body.removeAttribute('data-seasonal-no-logo')
  }
}

export function clearBodySeasonalAttributes(): void {
  if (!import.meta.client) {
    return
  }
  const body = document.body
  body.removeAttribute('data-seasonal-no-cursor')
  body.removeAttribute('data-seasonal-no-corner')
  body.removeAttribute('data-seasonal-no-logo')
}
